import { useTranslation } from 'react-i18next'

import { RHFSelect } from '@/shared/components/HookForm'

import { usePriceColumnOptions } from '../../../lib/usePriceColumnOptions'
import { FieldLoadError } from './FieldLoadError'

/** Special param type: a product column from the tactics-context field schemas. */
export const PriceColumnField = ({
	name,
	label,
	testId,
}: {
	name: string
	label: string
	testId?: string
}) => {
	const { t } = useTranslation()
	const { options, isLoading, isError, refetch } = usePriceColumnOptions()

	if (isError)
		return (
			<FieldLoadError
				label={label}
				onRetry={refetch}
				testId={testId}
				message={t('pr_tactic_price_columns_load_error', {
					defaultValue: "Couldn't load product columns.",
				})}
			/>
		)

	return (
		<RHFSelect
			name={name}
			label={label}
			options={options}
			isLoading={isLoading}
			disabled={isLoading}
			testId={testId}
			placeholder={t('general_select', {
				defaultValue: 'Select',
			})}
		/>
	)
}
